import type { PersonaId } from "@petci/domain";

const HOTEL_PERSONAS: ReadonlySet<PersonaId> = new Set(["P3"]);
const PM_PERSONAS: ReadonlySet<PersonaId> = new Set(["P4"]);
const RESIDENTIAL_PERSONAS: ReadonlySet<PersonaId> = new Set(["P1", "P2", "P5"]);

export function isHotelPersona(id: PersonaId): boolean {
  return HOTEL_PERSONAS.has(id);
}

export function isPropertyManager(id: PersonaId): boolean {
  return PM_PERSONAS.has(id);
}

export function isResidentialPersona(id: PersonaId): boolean {
  return RESIDENTIAL_PERSONAS.has(id);
}
